import { ViteReactSSG } from 'vite-react-ssg';
import RootLayout from './layouts/RootLayout';
import Home from './pages/Home';
import BlogIndex from './pages/BlogIndex';
import BlogPost from './pages/BlogPost';
import EastVsWest from './pages/EastVsWest';
import EventPage from './pages/EventPage';
import AthletePage from './pages/AthletePage';
import ExercisesIndex from './pages/ExercisesIndex';
import ExercisePage from './pages/ExercisePage';
import EquipmentIndex from './pages/EquipmentIndex';
import EquipmentPage from './pages/EquipmentPage';
import ToolsHub from './pages/tools/ToolsHub';
import WorkoutGeneratorPage from './pages/tools/WorkoutGeneratorPage';
import WorkoutGeneratorEmbed from './pages/tools/WorkoutGeneratorEmbed';
import HoldTimerPage from './pages/tools/HoldTimerPage';
import HoldTimerEmbed from './pages/tools/HoldTimerEmbed';
import CompetitionPlannerPage from './pages/tools/CompetitionPlannerPage';
import CompetitionPlannerEmbed from './pages/tools/CompetitionPlannerEmbed';
import MatchupPage from './pages/tools/MatchupPage';
import MatchupEmbed from './pages/tools/MatchupEmbed';
import { LOCALES, DEFAULT_LOCALE, type Lang } from './lib/i18n';
import './styles/index.css';
import './styles/iphone-frame.css';

const localeRoute = (lang: Lang) => ({
  path: lang === DEFAULT_LOCALE ? '/' : `/${lang}`,
  element: <RootLayout />,
  children: [
    { index: true, element: <Home lang={lang} /> },
    { path: 'blog', element: <BlogIndex lang={lang} /> },
    { path: 'blog/:slug', element: <BlogPost lang={lang} /> },
    { path: 'east-vs-west', element: <EastVsWest lang={lang} /> },
    { path: 'east-vs-west/athlete/:slug', element: <AthletePage lang={lang} /> },
    { path: 'east-vs-west/:slug', element: <EventPage lang={lang} /> },
    { path: 'armwrestling/exercises', element: <ExercisesIndex lang={lang} /> },
    { path: 'armwrestling/exercises/:slug', element: <ExercisePage lang={lang} /> },
    { path: 'armwrestling/equipment', element: <EquipmentIndex lang={lang} /> },
    { path: 'armwrestling/equipment/:slug', element: <EquipmentPage lang={lang} /> },
    { path: 'tools', element: <ToolsHub lang={lang} /> },
    { path: 'tools/armwrestling-workout-generator', element: <WorkoutGeneratorPage lang={lang} /> },
    { path: 'tools/armwrestling-workout-generator/embed', element: <WorkoutGeneratorEmbed lang={lang} /> },
    { path: 'tools/armwrestling-hold-timer', element: <HoldTimerPage lang={lang} /> },
    { path: 'tools/armwrestling-hold-timer/embed', element: <HoldTimerEmbed lang={lang} /> },
    { path: 'tools/armwrestling-competition-planner', element: <CompetitionPlannerPage lang={lang} /> },
    { path: 'tools/armwrestling-competition-planner/embed', element: <CompetitionPlannerEmbed lang={lang} /> },
    { path: 'tools/armwrestling-matchup', element: <MatchupPage lang={lang} /> },
    { path: 'tools/armwrestling-matchup/embed', element: <MatchupEmbed lang={lang} /> },
    { path: 'tools/armwrestling-matchup/:pair', element: <MatchupPage lang={lang} /> },
  ],
});

export const createRoot = ViteReactSSG({
  routes: LOCALES.map(localeRoute),
});
